import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import ArpRegistry from '../../../../features/arp-registry/ArpRegistry'
import useFeaturedMediaDrawerData from '../../../hooks/useFeaturedMediaDrawerData'
import CenteredLoadingAnimation from '../../core/CenteredLoadingAnimation'
import { Column, Row, StyledScrollable } from '../../core/Components'
import { StudioTab } from '../controls/common'
import { DrawerHeader } from './ActivityBarComponents'
import { ArtistSamplesItem, SongItem } from './ArtistMediaDropdown'
import { SamplePacks } from './sample-packs'

export const FeaturedTabs = {
  SONGS: 0,
  SAMPLES: 1,
  SAMPLE_PACKS: 2
}

const FeaturedMedia = () => {
  const { songsLoaded, samplesLoaded, songData, artistProfiles, samplesByArtist } =
    useFeaturedMediaDrawerData()
  const [selectedTab, setSelectedTab] = useState<number>(FeaturedTabs.SONGS)

  return (
    <Column
      className="h-100 w-100 studio-text-sm"
      style={{
        overflow: 'hidden',
        alignItems: 'stretch'
      }}
    >
      <DrawerHeader>Featured Sounds</DrawerHeader>
      <Row>
        <StudioTab
          onClick={() => setSelectedTab(FeaturedTabs.SONGS)}
          active={selectedTab === FeaturedTabs.SONGS}
        >
          Songs
        </StudioTab>
        <StudioTab
          onClick={() => setSelectedTab(FeaturedTabs.SAMPLES)}
          active={selectedTab === FeaturedTabs.SAMPLES}
        >
          Samples
        </StudioTab>
        <StudioTab
          onClick={() => setSelectedTab(FeaturedTabs.SAMPLE_PACKS)}
          active={selectedTab === FeaturedTabs.SAMPLE_PACKS}
        >
          Sample Packs
        </StudioTab>
      </Row>
      <Column css={{ overflowY: 'auto' }}>
        <StyledScrollable
          css={{ paddingTop: '10px', fontSize: '14px', paddingLeft: '6px', paddingRight: '6px' }}
        >
          {ArpRegistry.readyForStudioUse && (
            <>
              {selectedTab === FeaturedTabs.SONGS &&
                (songsLoaded ? (
                  songData.map((song, index: number, { length }) => (
                    <SongItem
                      songData={song}
                      hideBottomBorder={index + 1 === length}
                      key={song.id}
                    />
                  ))
                ) : (
                  <CenteredLoadingAnimation light />
                ))}
              {selectedTab === FeaturedTabs.SAMPLES &&
                (samplesLoaded ? (
                  <ArtistSamples
                    samplesByArtist={samplesByArtist}
                    artistProfiles={artistProfiles}
                  />
                ) : (
                  <CenteredLoadingAnimation light />
                ))}
            </>
          )}
          {selectedTab === FeaturedTabs.SAMPLE_PACKS && <SamplePacks />}
        </StyledScrollable>
      </Column>
    </Column>
  )
}

const ArtistSamples = ({ samplesByArtist, artistProfiles }) => {
  const [activeIndex, setActiveIndex] = useState(0)

  return (
    <>
      {Object.keys(samplesByArtist).map((artistEthAddress, index, { length }) => (
        <ArtistSamplesItem
          key={artistEthAddress}
          samples={samplesByArtist[artistEthAddress]}
          artistProfile={artistProfiles[artistEthAddress]}
          artistEthAddress={artistEthAddress}
          hideBottomBorder={index + 1 === length}
          isActive={index === activeIndex}
          setActiveIndex={setActiveIndex}
          index={index}
        />
      ))}
    </>
  )
}

export default observer(FeaturedMedia)
